export enum DateSelectBlock {
  Root = 'DateSelect',
}

export enum DateSelectElement {
  Control = 'control',
}
